import Types from "./actionTypes";
import Box from "./Box";


// I need to change this to put the response data on the facade I think
const initalResponses = {}; // If I can access the Ids of questions I could init stuff here...
const responseReducer = (responses, action, isBuildingLevel = false) => {
  if(!responses) {
    responses = initalResponses;
  }

  if(!!isBuildingLevel !== !action.facadeId) {
    return responses; // only look at the action if it was meant for these type of responses
  }

  switch (action.type) {
    case Types.SET_CHECKBOX: {
      const yesChecked = action.box === Box.YES
        && !(responses[action.id] && responses[action.id].yes);
      const noChecked = action.box === Box.NO
        && !(responses[action.id] && responses[action.id].no);
      
      return {
        ...responses,
        [action.id]: {
            yes: yesChecked,
            no: noChecked,
        }};
    }
    case Types.SET_DESIGN_FEATURE: {
      // ewww, this is gross, but I'll do it I guess...
      if(!isBuildingLevel) { // the conditional questions are facade-level
        return {
          ...responses,
          // are these in the building or the facade? -> uh oh!
          q09: {
            yes: false,
            no: false,
          },
          q10: {
            yes: false,
            no: false,
          },
        }
      } else {
        console.error("cannot reduce building-level set design feature");
        return responses;
      }
    }
    default:
      return responses;
  }
};

const initialImageSrc = "";
const imageReducer = (imageSrc, action) => {
  if(!imageSrc) {
    imageSrc = initialImageSrc;
  }

  switch(action.type) {
    case Types.SET_IMAGE_SRC: {
      return action.imageSrc;
    }
    default:
      return imageSrc;
  }
};

const designFeatureReducer = (state, action) => {
    switch(action.type) {
        case(Types.SET_DESIGN_FEATURE): {
            return action.index;
        }
        default:
            return state;
    }
};

const initialFacades = [];
const facadeReducer = (facades, action) => {
  if(!facades) {
    facades = initialFacades;
  }

  let facade = facades.find(f => f.facadeId === action.facadeId);
  if(facade) {
    // let the responses reducer do its magic!
    facades = [
      ...facades.filter(f => f.facadeId !== action.facadeId),
      {
        ...facade,
        responses: responseReducer(facade.responses, action),
        imageSrc: imageReducer(facade.imageSrc, action),
        designFeatureIndex: designFeatureReducer(facade.designFeatureIndex, action),
      },
    ];
  };

  switch(action.type) {
    case Types.ADD_FACADE: {
      return !facades.find(f => f.facadeId === action.facadeId)
      ? [
          ...facades,
          {
            facadeId: action.facadeId, // should I init everything?
          }
        ]
      : (alert("Cannot add duplicate facades"), facades);
    }
    case Types.DELETE_FACADE: {
      return facades.filter(f => f.facadeId !== action.facadeId); // this returns a new value... we're all good :)
    }
    default:
      return facades;
  }
};

const initialBuildings = [];
// we're going with this one!
const structureExample = [
  {
    buildingId: "house",
    q0: undefined,
    facades: [
      {
        facadeId: "front",
        imageSrc: "asldfkjlasdjk",
      },
    ],
  },
];
// bad
const otherStructure = {
  buildingId: {
    q0: undefined,
    front: {  // what if they name their building "q0"? -> badness!
      imageSrc: "asdlkfj;laskdjf",
    },
  },
};
const buildingReducer = (buildings, action) => {
  if(!buildings) {
    buildings = initialBuildings;
  }

  if(action.buildingId) {
    const building = buildings.find(b => b.buildingId === action.buildingId);
    if(building) {
      // let the facade reducer do its magic!
      buildings = [
        ...buildings.filter(b => b.buildingId !== action.buildingId),
        {
          ...building,
          responses: responseReducer(building.responses, action, true),
          facades: facadeReducer(building.facades, action),
        }
      ]
    } else {
      //throw new Error("could not find building!");
    }
  };

  switch(action.type) {
    case Types.ADD_BUILDING: {
      return !buildings.find(building => building.buildingId === action.buildingId)
      ? [
          ...buildings,
          {
            buildingId: action.buildingId, // should I init everything?
            facades: [],
          }
        ]
      : (alert("Cannot add duplicate buildings"), buildings);
    }
    case Types.DELETE_BUILDING: {
      return buildings.filter(b => b.buildingId !== action.buildingId); // this returns a new value... we're all good :)
    }
    default:
      return buildings;
  }
};

export default buildingReducer;


// WEBPACK FOOTER //
// ./src/modules/BuildingReducer.js